import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from './base-api.service';
import { Customer } from '../models';
import { expand, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@ApiService({ baseName: 'customers' })
export class CustomerApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  private static fromJSON(customer: any): Customer {
    return <Customer>customer;
  }

  // TODO: replace hand-rolled pagination loop with fetchAllPages (@fc-shared/utils/request-utils/fetch-all-pages)
  loadAll(): Observable<Customer[]> {
    return this.http.get<{ next: string; results: any[] }>(this.getUrl()).pipe(
      expand((results) => {
        if (!!results['next']) {
          return this.http.get<{ next: string; results: any[] }>(
            results['next'],
          );
        } else {
          return EMPTY;
        }
      }),
      map((res) => res['results']),
      map((res): Customer[] => {
        return res.map((customer: any) =>
          CustomerApiService.fromJSON(customer),
        );
      }),
    );
  }

  load(id: string): Observable<Customer> {
    return this.http
      .get(this.getUrl(id))
      .pipe(map((raw: Customer): Customer => CustomerApiService.fromJSON(raw)));
  }

  updateCustomerSettings(data: any): Observable<Customer> {
    return this.http.put(this.getUrl(data.id), data).pipe(
      map((resp: Customer) => {
        return CustomerApiService.fromJSON(resp);
      }),
    );
  }
}
